<template>
    <div class="container-fluid">
        <div class="row">
            <div
                class="col-sm-12 bg-white shadow-sm rounded-lg border mb-5"
                ref="fullscreenElement"
            >
                <div
                    class=" justify-content-end mt-1"
                    style="display: flex;"
                >
                    <div
                        class="btn btn-secondary btn-sm"
                        @click="toggleFullscreen"
                    ><i class="fas fa-expand mr-2"></i>FULL SCREEN</div>
                </div>
                <form
                    class="m-3"
                    @submit.prevent="submit"
                >
                    <div class="row">
                        <ul>
                            <template v-if="errors">
                                <li
                                    class="text-danger"
                                    v-for="(err, index) in errors"
                                    :key="'err-' + index"
                                >{{ handleValidationMessage(err[0]) }}</li>
                            </template>
                        </ul>
                    </div>
                    <div>
                        <div class="form-row bg-white">
                            <div class="col-md-3">
                                <div
                                    class="row no-gutters mt-2 mx-2 border rounded overflow-hidden flex-md-row mb-2 shadow-sm h-md-250 position-relative">
                                    <div class="col p-3 d-flex flex-column">
                                        <span class="d-inline-block text-muted">{{ trans.edit_mode }}</span>
                                        <div
                                            :class="{
                                                'text-dark': state === 'delete',
                                                'text-primary': state === 'link',
                                                'text-info': state === 'node'
                                            }"
                                            class="mb-0 mt-1"
                                        >
                                            <h4 class="mb-0">{{ state }}</h4>
                                        </div>
                                    </div>
                                    <div class="col p-2 flex-column align-content-center">
                                        <div class="d-flex justify-items-center flex-direction-column">
                                            <button
                                                class="btn btn-primary btn-sm m-1"
                                                @click="switchState"
                                                type="button"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    height="24px"
                                                    viewBox="0 -960 960 960"
                                                    width="24px"
                                                    fill="#FFFFFF"
                                                >
                                                    <path
                                                        d="M280-80 120-240l160-160 56 58-62 62h406v-160h80v240H274l62 62-56 58Zm-80-440v-240h486l-62-62 56-58 160 160-160 160-56-58 62-62H280v160h-80Z"
                                                    />
                                                </svg>
                                            </button>
                                            <button
                                                class="btn btn-secondary btn-sm m-1"
                                                @click="state = 'delete'"
                                                type="button"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    height="24px"
                                                    viewBox="0 -960 960 960"
                                                    width="24px"
                                                    fill="#FFFFFF"
                                                >
                                                    <path
                                                        d="m500-120-56-56 142-142-142-142 56-56 142 142 142-142 56 56-142 142 142 142-56 56-142-142-142 142Zm-220 0v-80h80v80h-80Zm-80-640h-80q0-33 23.5-56.5T200-840v80Zm80 0v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80q33 0 56.5 23.5T840-760h-80ZM200-200v80q-33 0-56.5-23.5T120-200h80Zm-80-80v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm640 0v-80h80v80h-80Z"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-9 mt-2 mb-2 align-content-end">
                                <div class="input-group justify-content-end">
                                    <select
                                        class="form-select"
                                        id="inputGroupSelect04"
                                        aria-label="Example select with button addon"
                                        v-model="locationNode"
                                        style="width: 100px;"
                                    >
                                        <option
                                            :value="location.id"
                                            v-for="location in remainingLocations"
                                            :key="'add-location-' + location.id"
                                        >{{ location.title }}</option>
                                    </select>
                                    <button
                                        class="btn btn-outline-primary  mx-1"
                                        type="button"
                                        @click="addNodeByLocation(locationNode)"
                                    >{{ trans.add_spot_node }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 bg-white shadow-sm rounded-lg border mb-2">

                                <form class="m-3">
                                    <!-- Map -->
                                    <div class="form-group row">
                                        <div
                                            id="map"
                                            style="width: 100%; height: 800px"
                                            class="mh-75"
                                        ></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <details>
                        <summary class="text-info">{{ trans.directions_guide_ttl }}</summary>
                        <div class="alert alert-light border-info bg-right">
                            <div class="mb-2">{{ trans.directions_guide1_ttl }}</div>
                            <div class="text-info mb-2 text-bold mt-3">{{ trans.directions_guide2_ttl }}</div>
                            <div class="mb-2">
                                <div class="text-bold">{{ trans.directions_guide3_sub }}</div>
                                <p>{{ trans.directions_guide3_text }}</p>
                            </div>
                            <div class="mb-2">
                                <div class="text-bold">{{ trans.directions_guide4_sub }}</div>
                                <div>{{ trans.directions_guide4_text }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="text-bold">{{ trans.directions_guide2_sub }}</div>
                                <p>{{ trans.directions_guide2_text }}</p>
                            </div>
                            <div class="mb-2">
                                <div class="text-bold">{{ trans.directions_guide7_sub }}</div>
                                <div>{{ trans.directions_guide7_text }}</div>
                            </div>
                            <div class="text-info mb-2 text-bold mt-3">{{ trans.directions_guide5_ttl }}</div>
                            <div class="mb-2">
                                <div class="text-bold">{{ trans.directions_guide5_sub }}</div>
                                <div>{{ trans.directions_guide5_text }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="text-bold">{{ trans.directions_guide6_sub }}</div>
                                <div>{{ trans.directions_guide6_text }}</div>
                            </div>
                        </div>
                    </details>
                    <div class="my-3">
                        <h4>{{ trans.node }}</h4>
                        <div class="scrollable border rounded p-2 my-1">
                            <div class="form-row">
                                <div
                                    class="form-group col-md-12 mt-2 mb-0 form-inline"
                                    v-for="node, i in nodes"
                                    :key="'node' + node.id + i"
                                >
                                    <div class="input-group mb-3 gap">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                {{
                                                    node.properties.name
                                                }}
                                            </span>
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Note"
                                                v-model="node.properties.comment"
                                                v-if="node.properties.type == 2 || node.properties.type == 4"
                                            >
                                        </div>
                                        <template v-if="node.properties.type != 3">
                                            <select
                                                class="custom-select"
                                                v-model="node.properties.type"
                                                @change="selectType(node)"
                                            >
                                                <option value="1">Type 1</option>
                                                <option value="2">Type 2</option>
                                                <option value="4">Type 4</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            <span class="input-group-text">Type 3</span>
                                            <span class="input-group-text">
                                                {{
                                                    getLocationTitle(
                                                        node.properties.location_id
                                                    )
                                                }}
                                            </span>
                                            <!-- &nbsp;
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input"
                                                    type="radio"
                                                    v-model="defaultSpot"
                                                    :value="`departure-${node.properties.name}`"
                                                    :id="`departure-${node.properties.name}`"
                                                    :checked="defaultSpot == `departure-${node.properties.name}`"
                                                    @click="uncheckDefaultSpot(defaultSpot)"
                                                >
                                                <label
                                                    class="form-check-label"
                                                    :for="`departure-${node.properties.name}`"
                                                >
                                                    Departure
                                                </label>
                                            </div>
                                            &nbsp;
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input"
                                                    type="radio"
                                                    v-model="defaultSpot"
                                                    :value="`destination-${node.properties.name}`"
                                                    :id="`destination-${node.properties.name}`"
                                                    :checked="defaultSpot == `destination-${node.properties.name}`"
                                                    @click="uncheckDefaultSpot(defaultSpot)"
                                                >
                                                <label
                                                    class="form-check-label"
                                                    :for="`destination-${node.properties.name}`"
                                                >
                                                    Destination
                                                </label>
                                            </div> -->
                                        </template>
                                        <template v-if="node.properties.type == 2">
                                            <div
                                                v-for="transitionId, nodeTransIndex in node.properties.transition_ids"
                                                :key="`node-${node.id}-${nodeTransIndex}-${transitionId}`"
                                            >
                                                <select
                                                    class="custom-select"
                                                    @change="addTransition(node, nodeTransIndex, $event)"
                                                >
                                                    <option value="">Choose</option>
                                                    <option
                                                        :value="transitionNode.id"
                                                        v-for="transitionNode in transitionNodes"
                                                        :key="'transition-node-' + transitionNode.id"
                                                        :selected="transitionId == transitionNode.id"
                                                        :disabled="node.properties.transition_ids.includes(transitionNode.id)"
                                                    >
                                                        {{
                                                            `${getLayerTitle(transitionNode.layer_id)}(${transitionNode.layer_id})
                                                                                                                - ${transitionNode.name}`
                                                        }}
                                                        {{ transitionNode.comment ?
                                                            `:${transitionNode.comment}` : "" }}
                                                    </option>
                                                </select>
                                                <div
                                                    class="btn-group"
                                                    v-if="facilities.length > 0"
                                                >
                                                    <button
                                                        type="button"
                                                        class="btn btn-info disabled"
                                                    >{{ node.properties.facility_id ?
                                                        getFacility(node.properties.facility_id) : "Choose" }}</button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-info dropdown-toggle dropdown-icon"
                                                        data-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <span class="sr-only">Toggle Dropdown</span>
                                                    </button>
                                                    <div
                                                        class="dropdown-menu"
                                                        role="menu"
                                                        style=""
                                                    >
                                                        <a
                                                            class="dropdown-item"
                                                            href="javascript:void(0)"
                                                            v-for="facility in facilities"
                                                            :key="`node${node.properties.id}-transitionNode${transitionId}-facility${facility.id}`"
                                                            @click="node.properties.facility_id = facility.id"
                                                        >{{ facility.title }}</a>
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn-tool"
                                                    @click="deleteTransition(node, nodeTransIndex)"
                                                >
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                @click="addTransition(node)"
                                            ><i class="fas fa-plus"></i></button>
                                        </template>
                                        <template v-if="node.properties.type == 4">
                                            <div
                                                v-for="nodeId, i in node.properties.other_parcel_node_ids"
                                                :key="`other-node-${i}-${nodeId}`"
                                            >
                                                <select
                                                    class="custom-select"
                                                    @change="changeParcelTransition($event, node, i)"
                                                >
                                                    <option value="">Choose</option>
                                                    <option
                                                        v-for="otherNode in otherNodes"
                                                        :value="otherNode.id"
                                                        :key="`select-link-${i}-${otherNode.id}`"
                                                        :selected="nodeId == otherNode.id"
                                                        :disabled="node.properties.other_parcel_node_ids.includes(otherNode.id)"
                                                    >
                                                        {{
                                                            `Floormap: ${otherNode.layer.parcel.title} - Layer:
                                                                                                                ${otherNode.layer.title} - Node: ${otherNode.name}`
                                                        }}
                                                        {{ otherNode.comment ?
                                                            `:${otherNode.comment}` : "" }}
                                                    </option>
                                                </select>
                                                <div
                                                    class="btn-group"
                                                    v-if="facilities.length > 0"
                                                >
                                                    <button
                                                        type="button"
                                                        class="btn btn-info disabled"
                                                    >{{ node.properties.facility_id ?
                                                        getFacility(node.properties.facility_id) : "Choose" }}</button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-info dropdown-toggle dropdown-icon"
                                                        data-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <span class="sr-only">Toggle Dropdown</span>
                                                    </button>
                                                    <div
                                                        class="dropdown-menu"
                                                        role="menu"
                                                        style=""
                                                    >
                                                        <a
                                                            class="dropdown-item"
                                                            href="javascript:void(0)"
                                                            v-for="facility in facilities"
                                                            :key="`node${node.properties.id}-transitionNode${nodeId}-facility${facility.id}`"
                                                            @click="node.properties.facility_id = facility.id"
                                                        >{{ facility.title }}</a>
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn-tool"
                                                    @click="deleteParcelTransition(node, i)"
                                                >
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                @click="addParcelTransition(node)"
                                            ><i class="fas fa-plus"></i></button>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="my-4">
                        <h4>{{ trans.link }}</h4>
                        <div class="scrollable border rounded p-2 my-3">
                            <div class="form-row">
                                <div
                                    class="form-group col-md-12 mt-2 form-inline mb-0"
                                    v-for="(link, index) in links"
                                    :key="'link-' + index"
                                >
                                    <div class="input-group mb-3 gap">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                {{
                                                    link.properties.source +
                                                    " - " +
                                                    link.properties.target
                                                }}
                                            </span>
                                            <div class="input-group-text">
                                                &nbsp; Accessibility &nbsp;
                                                <input
                                                    type="checkbox"
                                                    v-model="link.properties.accessibility"
                                                    :true-value="1"
                                                    :false-value="0"
                                                />
                                                <span class="ml-3 mr-1">Weight</span>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    class="form-control form-control-sm"
                                                    style="width:4.5rem;"
                                                    v-model="link.properties.weight"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-3"></div>
                        <div class="col-sm-9">
                            <button
                                type="submit"
                                class="btn btn-primary w-25 float-right"
                                :disabled="isDisabled"
                            >{{ graphData ? trans.update : trans.create }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import MapBox from "../mixins/MapBox/Map";
import * as turf from "@turf/turf";
import Graph from "../lib/Graph";

export default {
    props: {
        layer: {
            type: Object,
            required: true,
        },
        graphData: {
            type: Object,
            default: function () {
                return null;
            },
        },
        nodeData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        transitionNodes: {
            type: Array,
            default: function () {
                return [];
            },
        },
        linkData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        locations: {
            type: Array,
            default: [],
        },
        trans: {
            type: Object,
            required: true,
        },
        formAction: {
            type: String,
            required: true,
        },
        otherNodes: {
            type: Array,
            default: []
        },
        otherLinks: {
            type: Array,
            default: []
        },
        otherLayers: {
            type: Array,
            default: []
        },
        facilities: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    mixins: [MapBox],
    data() {
        return {
            state: "node",
            nodes: [],
            links: [],
            hoveredNodeId: null,
            isDisabled: false,
            org: "",
            dest: "",
            errors: {},
            from: "",
            to: "",
            locationNode: "",
            selectedNode: "",
            defaultSpot: ""
        };
    },
    computed: {
        remainingLocations() {
            return this.locations.filter(
                (el) =>
                    !this.nodes.some(
                        (node) => node.properties.location_id == el.id
                    )
            );
        },
    },
    methods: {
        submit() {
            var self = this;
            this.isDisabled = true;

            axios({
                method: "PUT",
                url: this.formAction,
                data: {
                    nodes: this.nodes,
                    links: this.links
                },
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        window.location.replace(response.data.redirectTo);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                        console.error(this.errors);
                    }
                });
        },
        loadImageries() {
            if (this.layer.imageries.length == 0) return;

            this.layer.imageries.forEach((imagery) => {
                const sourceId = "imagery-source-" + imagery.id;
                const layerId = "imagery-layer-" + imagery.id;

                this.mySmartMap.addSource(sourceId, {
                    type: "image",
                    url: imagery.image_url,
                    coordinates: imagery.coordinates,
                });
                this.mySmartMap.addLayer({
                    id: layerId,
                    type: "raster",
                    source: sourceId,
                    paint: {
                        "raster-fade-duration": 0,
                    },
                });
            });
        },
        switchState() {
            this.state = this.state == "node" ? "link" : "node";
        },
        calculateDistance(p1, p2) {
            var from = turf.point(p1);
            var to = turf.point(p2);

            return turf.distance(from, to);
        },
        getNextNodeId() {
            var i = -1;
            do {
                i += 1;
                var found = this.nodes.find(el => el.properties.name == `N${i}`);
            } while (found);

            return i;
        },
        addTransition(node, transIndex, e) {
            if (!e) {
                node.properties.transition_ids.push("");
                return;
            }

            node.properties.transition_ids[transIndex] = parseInt(e.target.value);
        },
        addParcelTransition(node) {
            if (!node.properties.other_parcel_node_ids) {
                node.properties.other_parcel_node_ids = [""];
                return;
            }
            node.properties.other_parcel_node_ids.push("");
        },
        changeParcelTransition(e, node, index) {
            node.properties.other_parcel_node_ids[index] = parseInt(e.target.value);
        },
        deleteTransition(node, transIndex) {
            node.properties.transition_ids.splice(transIndex, 1);
        },
        deleteParcelTransition(node, index) {
            node.properties.other_parcel_node_ids.splice(index, 1);
        },
        addNode(coord, options) {
            var id = this.getNextNodeId();

            var point = turf.point(
                [coord[0], coord[1]],
                {
                    type: options.type ?? 1,
                    name: options.name ? options.name : "N" + id,
                },
                {
                    id: id,
                }
            );
            if (options.location_id) {
                point.properties.location_id = options.location_id;
            }
            point.properties.default_spot_type = options.default_spot_type ? options.default_spot_type : 0;
            point.properties.transition_ids = options.type == 2 && options.transition_ids ? options.transition_ids : [];
            point.properties.other_parcel_node_ids = options.other_parcel_node_ids ?? [];
            point.properties.facility_id = options.facility_id ?? '';
            point.properties.comment = options.comment ?? '';

            this.nodes.push(point);
        },
        deleteNode(name) {
            var removeId;
            var temp = [];
            const nodeLength = this.nodes.length;
            for (let i = 0; i < nodeLength; i++) {
                const el = this.nodes[i];
                if (el.properties.name == name) {
                    removeId = el.id;
                    continue;
                }

                temp.push(el);
            }
            this.nodes = temp;

            this.links = this.links.filter(
                (el) =>
                    el.properties.source != name && el.properties.target != name
            );
        },

        deleteLink(payload) {
            this.links = this.links.filter(
                (el) =>
                    el.properties.source != payload.properties.source ||
                    el.properties.target != payload.properties.target
            );
        },
        hideLocation(location) {
            return this.nodes.some(
                (node) => node.properties.location_id == location.id
            );
        },
        selectType(node) {
            if (node.properties.type == 3) {
                return;
            }

            delete node.properties.location_id;
        },
        fetchNodeData() {
            this.nodeData.forEach((node) => {
                if (node.layer_id == this.layer.id) {
                    var otherParcelNodeIds = [];
                    this.otherLinks.forEach(el => {
                        let arr = [el.source, el.target];
                        if (arr.includes(node.id) && !otherParcelNodeIds.some(item => arr.includes(item))) {
                            otherParcelNodeIds.push(el.source == node.id ? el.target : el.source);
                        }
                    })
                    this.addNode(
                        [node.lng, node.lat],
                        {
                            name: node.name,
                            type: node.type,
                            location_id: node.location_id,
                            transition_ids: node.transition_ids,
                            other_parcel_node_ids: otherParcelNodeIds,
                            facility_id: node.facility_id,
                            comment: node.comment,
                            default_spot_type: node.default_spot_type
                        }
                    );
                    if (node.default_spot_type) {
                        this.defaultSpot = node.default_spot_type == 1 ? `departure-${node.name}` : `destination-${node.name}`;
                    }
                }
            });
        },
        fetchLinkData() {
            this.linkData.forEach((link) => {
                const source = this.nodeData.find((el) => el.id == link.source);
                const target = this.nodeData.find((el) => el.id == link.target);
                const coord1 = [source.lng, source.lat];
                const coord2 = [target.lng, target.lat];
                var linestring = turf.lineString([coord1, coord2], {
                    source: source.name,
                    target: target.name,
                    distance: link.distance,
                    weight: link.weight,
                    accessibility: link.accessibility,
                });
                this.links.push(linestring);
            });
        },
        addNodeByLocation(locationId) {
            const location = this.locations.find((el) => el.id == locationId);
            this.addNode([location.lng, location.lat], { type: 3, location_id: locationId });
        },
        getLocationTitle(locationId) {
            return this.locations.find((el) => el.id == locationId)?.title;
        },
        onNodeMove(e) {
            this.mySmartMap.getCanvasContainer().style.cursor = 'grabbing';
            const coords = e.lngLat;
            const index = this.nodes.findIndex(el => el.properties.name == this.selectedNode);
            this.nodes[index].geometry.coordinates = [coords.lng, coords.lat];
            var result = [];
            this.links.forEach(el => {
                if (el.properties.source == this.selectedNode) {
                    el.geometry.coordinates[0] = [coords.lng, coords.lat];
                } else if (el.properties.target == this.selectedNode) {
                    el.geometry.coordinates[1] = [coords.lng, coords.lat];
                }
                result.push(el);
            });

            this.links = result;
        },
        onNodeUp(e) {
            this.mySmartMap.getCanvasContainer().style.cursor = '';
            // Unbind mouse/touch events
            this.mySmartMap.off('mousemove', this.onNodeMove);
            this.mySmartMap.off('touchmove', this.onNodeMove);
        },
        async toggleFullscreen() {
            const elem = this.$refs.fullscreenElement;
            if (!document.fullscreenElement) {
                try {
                    await elem.requestFullscreen();
                    elem.classList.add('scrollable'); // フルスクリーンにする際にクラスを追加
                } catch (err) {
                    alert(`Unable to enter fullscreen mode: ${err.message}`);
                }
            } else {
                document.exitFullscreen();
                elem.classList.remove('scrollable'); // フルスクリーンから戻る際にクラスを削除
            }
        },
        getOtherLinks(node) {
            const found = this.nodeData.find(el => el.name == node.properties.name);
            return this.otherLinks.filter(el => [el.source, el.target].includes(found.id));
        },
        getFacility(facilityId) {
            return this.facilities.find(el => el.id == facilityId).title;
        },
        getLayerTitle(id) {
            return this.otherLayers.find(el => el.id == id).title;
        },
        uncheckDefaultSpot(val) {
            if (!val) return;

            this.defaultSpot = "";
        },
        handleValidationMessage(err) {
            const matched = err.match(/nodes\.([0-9]+)\.properties\.location_id/);
            console.log(matched);
            if (!matched[1]) {
                return err;
            }

            const node = this.nodes[matched[1]];

            return err.replace(/nodes\.([0-9]+)\.properties/, node.properties.name);
        }
    },
    created() {
        this.fetchNodeData();
        this.fetchLinkData();
    },
    mounted() {
        var self = this;
        const canvas = this.mySmartMap.getCanvasContainer();
        this.mySmartMap.on("load", function () {
            self.loadImageries();
            self.mySmartMap.addSource("nodes", {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: self.nodes,
                },
            });
            self.mySmartMap.addSource("links", {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: self.links,
                },
            });

            self.mySmartMap.addLayer({
                id: "links",
                type: "line",
                source: "links",
                layout: {
                    "line-join": "round",
                },
                paint: {
                    "line-color": [
                        "case",
                        ["==", ["get", "accessibility"], 1], "blue",
                        "red"
                    ],
                    "line-width": 4,
                    "line-opacity": 0.8,
                },
            });
            self.mySmartMap.addLayer({
                id: "nodes",
                type: "circle",
                source: "nodes",
                paint: {
                    "circle-color": [
                        "case",
                        ["==", ["get", "type"], 2], "green",
                        ["==", ["get", "type"], 3], "red",
                        ["==", ["get", "type"], 4], "yellow",
                        "#94e3ca"
                    ],
                    "circle-radius": [
                        "case",
                        ["boolean", ["feature-state", "hover"], false],
                        15,
                        12,
                    ],
                    "circle-stroke-width": [
                        "case",
                        ["boolean", ["feature-state", "hover"], false],
                        2,
                        0,
                    ],
                    "circle-stroke-color": [
                        "case",
                        ["boolean", ["feature-state", "hover"], false],
                        "#a83636",
                        "#94e3ca",
                    ],
                },
            });
            self.mySmartMap.addLayer({
                id: "nodes_label",
                type: "symbol",
                source: "nodes",
                layout: {
                    "text-field": ["get", "name"],
                    "text-size": 10,
                },
            });
            // add link
            self.mySmartMap.on("click", "nodes", (e) => {
                if (self.state != "link") {
                    return;
                }
                const point = e.features[0];

                if (!self.org) {
                    self.org = point;
                    return;
                }
                if (self.org.properties.name == point.properties.name) {
                    alert("please select another node");
                    return;
                }

                self.dest = point;
                var coord1 = self.org.geometry.coordinates.slice();
                var coord2 = self.dest.geometry.coordinates.slice();
                var linestring = turf.lineString([coord1, coord2], {
                    source: self.org.properties.name,
                    target: self.dest.properties.name,
                    distance: self.calculateDistance(coord1, coord2),
                    weight: 0,
                    accessibility: 1,
                });
                self.links.push(linestring);
                self.org = "";
            });
            // add node
            self.mySmartMap.on("click", (e) => {
                if (self.hoveredNodeId || self.state != "node") {
                    return;
                }
                self.addNode([e.lngLat.lng, e.lngLat.lat], {});
            });
            // delete node 
            self.mySmartMap.on("click", "nodes", (e) => {
                if (self.state != "delete") {
                    return;
                }
                self.deleteNode(e.features[0].properties.name);
            });
            // hover delete
            self.mySmartMap.on("mousemove", "links", (e) => {
                if (self.state != "delete") {
                    return;
                }
                canvas.style.cursor = "not-allowed";
            });

            self.mySmartMap.on("mouseleave", "links", (e) => {
                canvas.style.cursor = "";
            });
            self.mySmartMap.on("click", "links", (e) => {
                if (self.state != "delete") {
                    return;
                }
                self.deleteLink(e.features[0]);
            });
            // change node style when hover
            self.mySmartMap.on("mousemove", "nodes", (e) => {
                if (self.state == "delete") {
                    canvas.style.cursor = "not-allowed";
                }
                if (e.features.length > 0) {
                    if (self.hoveredNodeId !== null) {
                        self.mySmartMap.setFeatureState(
                            { source: "nodes", id: self.hoveredNodeId },
                            { hover: false }
                        );
                    }
                    self.hoveredNodeId = e.features[0].id;
                    self.mySmartMap.setFeatureState(
                        { source: "nodes", id: self.hoveredNodeId },
                        { hover: true }
                    );
                }
            });
            // remove node style after hover
            self.mySmartMap.on("mouseleave", "nodes", () => {
                canvas.style.cursor = "";
                if (self.hoveredNodeId !== null) {
                    self.mySmartMap.setFeatureState(
                        { source: "nodes", id: self.hoveredNodeId },
                        { hover: false }
                    );
                }
                self.hoveredNodeId = null;
            });
            self.mySmartMap.on('mouseenter', 'nodes', () => {
                canvas.style.cursor = 'move';
            });
            self.mySmartMap.on('mousedown', 'nodes', (e) => {
                // Prevent the default map drag behavior.
                e.preventDefault();

                self.selectedNode = e.features[0].properties.name;
                canvas.style.cursor = 'grab';

                self.mySmartMap.on('mousemove', self.onNodeMove);
                self.mySmartMap.once('mouseup', self.onNodeUp);
            });
        });
    },
    watch: {
        nodes: {
            deep: true,
            handler: function (newVal) {
                if (!this.mySmartMap || !this.mySmartMap.getSource("nodes")) {
                    return;
                }

                this.mySmartMap.getSource("nodes").setData({
                    type: "FeatureCollection",
                    features: newVal,
                });
            },
        },
        links: {
            deep: true,
            handler: function (newVal) {
                if (!this.mySmartMap || !this.mySmartMap.getSource("links")) {
                    return;
                }

                this.mySmartMap.getSource("links").setData({
                    type: "FeatureCollection",
                    features: newVal,
                });
            }
        },
        defaultSpot(newVal) {
            this.nodes.forEach((node, index) => {
                this.nodes[index].properties.default_spot_type = newVal.indexOf(node.properties.name) == -1 ? 0 : (newVal.indexOf('departure') != -1 ? 1 : 2);
            })
        }
    },
};
</script>
<style>
.scrollable {
    max-height: 400px;
    overflow-y: auto;
}

.gap {
    gap: 3px;
}
</style>
